import PropTypes from 'prop-types'
import { Element } from '../../common/html/element'

const Layout = ({ children }) => {
  return (
    <Element
      className="wh100 dFlex justifyContentCenter"
      style={{ backgroundColor: '#e5e5e5', overflow: 'hidden' }}
    >
      <Element
        className="wh100 flexColumn px3 pt2"
        style={{ backgroundColor: '#ffffff', maxWidth: 1000, rowGap: '12px' }}
      >
        {children}
      </Element>
    </Element>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
